<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="2.8" y="3.8" width="14.4" height="12.4" rx="2"/><circle cx="7.4" cy="8" r="1.4"/><path d="M3.4 14.2 7.6 10l3 2.8 2.6-2.2 3.4 3"/></svg>
</template>
